import PropTypes from 'prop-types';

import CommentItem, { commentShape } from './CommentItem';

const CommentsList = ({ comments }) => (
  <>
    <h3 className="font-medium text-lg text-black tracking-wider mb-4">
      Comments
      {' '}
      {comments ? `(${comments.length})` : '(0)'}
    </h3>
    <ul className="grid gap-4">
      {comments.map((comment) => <CommentItem {...comment} key={comment.id} />)}
    </ul>
  </>
);

CommentsList.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.shape(commentShape)).isRequired,
};

export default CommentsList;
